module.exports = __webpack_public_path__ + "img/epr-article-top-img_medium@2x.0c742279.webp";